/** Mirrors backend POST_SALES_KPI — keep in sync with post-sales-kpi.util.ts */
export const POST_SALES_KPI = {
  PENDING_PAYMENT: 'pending_payment',
  COMPLETED: 'completed',
  RETURNED: 'returned',
  EXCHANGED: 'exchanged',
} as const;

export type PostSalesKpi = (typeof POST_SALES_KPI)[keyof typeof POST_SALES_KPI];

export const POST_SALES_KPI_LABELS: Record<PostSalesKpi, string> = {
  pending_payment: 'Pendientes de pago',
  completed: 'Completadas',
  returned: 'Devueltas',
  exchanged: 'Piezas intercambiadas',
};

export function isPostSalesKpi(value: string | undefined | null): value is PostSalesKpi {
  return (
    value === POST_SALES_KPI.PENDING_PAYMENT ||
    value === POST_SALES_KPI.COMPLETED ||
    value === POST_SALES_KPI.RETURNED ||
    value === POST_SALES_KPI.EXCHANGED
  );
}
